export const HeaderTitle = 'Pro Xtra';
// eslint-disable-next-line max-len
export const spendToolTipLabel = 'Pro Xtra Loyalty Spend Includes transactions made with Pro Xtra ID or registered tender.';
export const spendToolTipLabel1 = 'Excludes taxes, shipping fees, returns, and gift card purchases.';
export const spendToolTipLabel2 = 'Savings includes amount saved from discounts on full price product,';
export const spendToolTipLabel3 = 'other markdowns, bulk discounts and Pro Xtra exclusive savings.';
export const graphqlEndpoint = 'homepageWelcomeCard';
export const availablePerksEndpoint = 'availablePerksCount';

// Promotions
export const promotionText = {
  PreferredPricingPromo: 'Getting Closer to Preferred Pricing',
  VolumePricingPromo: 'Save Money with Volume Pricing',
  PlccAcquisitionPromo: 'The New Pro Xtra Credit Card',
  TextToConfirmPromo: 'Approve Purchases via Text',
  PaintProductsPromo: 'Save 20% on paint products',
  ProXtraGeneralKnowledgePromo: 'Get Rewarded with Pro Xtra',
  ManageProjectMore: 'Manage Projects more effectively',
  RegisteredTender: 'Easy Purchase Tracking',
  AppAwarenessPromo: 'Easily Manage Member Benefits',
  ProOnlineExperiencePromo: 'Online Business Tools',
};

// Tile Constants
export const TILE_LIMIT = 4;
export const TILE_TYPE = { NOTIFICATION: 'NOTIFICATION', PROMOTION: 'PROMOTION' };

// Analytics
const analyticsPrefix = { welcomeCard: 'homepage: welcome:', };
export const analytics = {
  NOTIFICATION: {
    PREFIX: `${analyticsPrefix.welcomeCard} not:`,
    perkStatus: 'perks status: until your next perk',
    availablePerks: 'available perks: your available perks',
    pricingUnlocked: 'pricing unlocked: getting close to unlocking paint rewards',
  },
  PROMOTION: {
    PREFIX: `${analyticsPrefix.welcomeCard} promo:`,
    ProXtraGeneralKnowledgePromo: 'px general knowledge',
    PreferredPricingPromo: 'preferred pricing tier 0',
    PlccAcquisitionPromo: 'plcc acquisition',
    ProOnlineExperiencePromo: 'pro online experience',
    TextToConfirmPromo: 'text 2 confirm',
    RegisteredTender: 'register tender',
    AppAwarenessPromo: 'app awareness',
    VolumePricingPromo: 'vpp',
  },
  FOOTER: {
    PREFIX: `${analyticsPrefix.welcomeCard} nav:`,
    Perks: 'perks',
    Pricing: 'pricing',
    Offer: 'offers',
  },
};
